import Vue from 'vue'
import VueRouter from 'vue-router'
import VueAxios from 'vue-axios'
import axios from 'axios'
import App from '@/App.vue'
import router from '@/router'
import { buildStore } from '@/store/index'
import VueTextareaAutosize from 'vue-textarea-autosize'
import VueClipboard from 'vue-clipboard2'
import Snotify from 'vue-snotify';
import VueScrollTo from 'vue-scrollto';
import LinkPrevue from 'link-prevue'
import VueTimers from 'vue-timers'
import { Editor, EditorContent } from 'tiptap'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBars } from '@fortawesome/pro-light-svg-icons/faBars'
import { faComments as falComments } from '@fortawesome/pro-light-svg-icons/faComments'
import { faComments as farComments } from '@fortawesome/pro-regular-svg-icons/faComments'
import { faComments as fasComments } from '@fortawesome/pro-solid-svg-icons/faComments'
import { faComment as falComment } from '@fortawesome/pro-light-svg-icons/faComment'
import { faComment as farComment } from '@fortawesome/pro-regular-svg-icons/faComment'
import { faComment as fasComment } from '@fortawesome/pro-solid-svg-icons/faComment'
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser'
import { faPlusCircle } from '@fortawesome/pro-light-svg-icons/faPlusCircle'
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus'
import { faPencilAlt } from '@fortawesome/pro-light-svg-icons/faPencilAlt'
import { faCommentAlt } from '@fortawesome/pro-light-svg-icons/faCommentAlt'
import { faCommentAltPlus } from '@fortawesome/pro-light-svg-icons/faCommentAltPlus'
import { faCommentAltCheck } from '@fortawesome/pro-light-svg-icons/faCommentAltCheck'
import { faPenSquare } from '@fortawesome/pro-light-svg-icons/faPenSquare'
import { faTimesSquare } from '@fortawesome/pro-light-svg-icons/faTimesSquare'
import { faCheckSquare } from '@fortawesome/pro-light-svg-icons/faCheckSquare'
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck'
import { faCheckCircle as falCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle'
import { faCheckCircle as fasCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faQuestionCircle as falQuestionCircle } from '@fortawesome/pro-light-svg-icons/faQuestionCircle'
import { faQuestionCircle as fasQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle'
import { faTimesCircle as falTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle'
import { faTimesCircle as fasTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle'
import { faUserCheck as falUserCheck } from '@fortawesome/pro-light-svg-icons/faUserCheck'
import { faUserCheck as fasUserCheck } from '@fortawesome/pro-solid-svg-icons/faUserCheck'
import { faThumbtack as falThumbtack } from '@fortawesome/pro-light-svg-icons/faThumbtack'
import { faThumbtack as fasThumbtack } from '@fortawesome/pro-solid-svg-icons/faThumbtack'
import { faThumbsUp as falThumbsUp } from '@fortawesome/pro-light-svg-icons/faThumbsUp'
import { faThumbsUp as fasThumbsUp } from '@fortawesome/pro-solid-svg-icons/faThumbsUp'
import { faShareSquare } from '@fortawesome/pro-light-svg-icons/faShareSquare'
import { faUndoAlt } from '@fortawesome/pro-regular-svg-icons/faUndoAlt'
import { faSignInAlt as falSignInAlt } from '@fortawesome/pro-light-svg-icons/faSignInAlt'
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown'
import { faBold } from '@fortawesome/pro-light-svg-icons/faBold'
import { faStrikethrough } from '@fortawesome/pro-light-svg-icons/faStrikethrough'
import { faItalic } from '@fortawesome/pro-light-svg-icons/faItalic'
import { faUnderline } from '@fortawesome/pro-light-svg-icons/faUnderline'
import { faParagraph } from '@fortawesome/pro-light-svg-icons/faParagraph'
import { faH1 } from '@fortawesome/pro-light-svg-icons/faH1'
import { faH2 } from '@fortawesome/pro-light-svg-icons/faH2'
import { faH3 } from '@fortawesome/pro-light-svg-icons/faH3'
import { faListUl } from '@fortawesome/pro-light-svg-icons/faListUl'
import { faListOl } from '@fortawesome/pro-light-svg-icons/faListOl'
import { faQuoteLeft } from '@fortawesome/pro-light-svg-icons/faQuoteLeft'

library.add(
  faBars,
  falComments,
  farComments,
  fasComments,
  falComment,
  farComment,
  fasComment,
  faUser,
  faPlusCircle,
  faPlus,
  faPencilAlt,
  faCommentAlt,
  faCommentAltCheck,
  faCommentAltPlus,
  faCheck,
  faCheckSquare,
  faPenSquare,
  faTimesSquare,
  falCheckCircle,
  fasCheckCircle,
  falQuestionCircle,
  fasQuestionCircle,
  falTimesCircle,
  fasTimesCircle,
  falUserCheck,
  fasUserCheck,
  falThumbtack,
  fasThumbtack,
  falThumbsUp,
  fasThumbsUp,
  faShareSquare,
  faUndoAlt,
  falSignInAlt,
  faCaretRight,
  faCaretDown,
  faBold,
  faStrikethrough,
  faItalic,
  faUnderline,
  faParagraph,
  faH1,
  faH2,
  faH3,
  faListUl,
  faListOl,
  faQuoteLeft
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('link-prevue', LinkPrevue)

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueAxios, axios)

Vue.use(VueTextareaAutosize)
Vue.use(VueClipboard)
Vue.use(Snotify, { toast: { showProgressBar: false, position: 'rightTop' } })
Vue.use(VueScrollTo)
Vue.use(VueTimers)
Vue.use(EditorContent)

new Vue({
  router,
  store: buildStore(),
  render: h => h(App)
}).$mount('#app')
